module.exports = __webpack_public_path__ + "img/secondary_4x4_z18.8401c038.svg";